<template>
  <div class="flex flex-column align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-12 md:w-10 lg:w-10 xl:w-6 mb-2">
      <template #title>BALÍK</template>
      <template #subtitle >
        <div class="mb-3 border-solid border-1 surface-border">
        </div>
        <div class="field flex justify-content-center">
          <router-link to="/mod-stock/scan-item" class="w-full">
            <PrimevueButton label="Skenovať QR kód" severity="success" icon="pi pi-camera" text raised class="uppercase w-full"/>
          </router-link>
        </div>
        <div class="field flex justify-content-center">
          <PrimevueButton @click="printLabel()" label="Vytlač štítok" 
            :disabled="!(this.multiPack.id > 0)" icon="pi pi-print"
            severity="success" text raised class="w-full uppercase"/>
        </div>
      </template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="packageForm">
            <div class="flex flex-wrap">
              
              <div class="w-12 md:w-6 lg:w-6 p-1">
                
                <div class="grid ml-0 mr-0">
                  <div class="col-2 pl-0 pr-1 pb-0">
                    <div class="field mb-1">
                      <label class="mb-1" for="multipackage-code">Kód</label>
                      <InputText class="w-full" 
                        disabled
                        v-model="this.multiPack.code"
                        type="text"
                        name="multipackage-code"
                        id="multipackage-code"
                      >
                      </InputText>
                    </div>
                  </div>

                  <div class="col-4 pl-0 pr-1 pb-0">
                    <div class="field mb-1">
                      <label class="mb-1" for="package-location">Umiestnenie</label>
                      <InputText class="w-full" 
                        
                        v-model="this.multiPack.location"
                        type="text"
                        name="package-location"
                        id="package-location"
                      >
                      </InputText>
                    </div>
                  </div>

                  <div class="col-6 pl-0 pr-0 pb-0">
                    <div class="field mb-1">
                      <div class="flex align-items-center justify-content-between" style="margin-bottom: 0rem;">
                        <span class="mb-1">Farba</span>
                        <div class="flex align-items-center justify-content-right"> 
                          <label for="imitation" class="mr-2 mb-1">Imit. dreva</label>
                          <PrimevueCheckbox 
                            v-model="this.imitation" inputId="imitation" name="imitation" :binary="true"
                            @change="setColors()"
                          />
                          
                        </div>
                      </div>
                      <PrimevueSelect
                          id="package-color"
                          
                          v-model="this.selectedColor"
                          :options="this.colors"
                          optionLabel="code"
                          placeholder="Vyber farbu"
                          class="w-full"
                          :class="`${v$.selectedColor.$error ? 'bg-red-200' : ''}`"
                          :invalid="v$.selectedColor.$error"
                      >
                      <template #value="slotProps">
                        <div v-if="slotProps.value.id != 0" class="flex align-items-center">
                            <div
                              class="color-box mr-2"
                              :style="{ backgroundColor: slotProps.value.colorHash }"
                            ></div>  
                            <div>{{ slotProps.value.code }}</div>
                        </div>
                        <span v-else>
                          {{ slotProps.placeholder }}
                        </span>
                      </template>
                      <template #option="slotProps">
                          <div class="flex align-items-center">
                              <div
                                class="color-box mr-2"
                                :style="{ backgroundColor: slotProps.option.colorHash }"
                              ></div>  
                              <div>{{ slotProps.option.code }}</div>
                          </div>
                      </template>
                      </PrimevueSelect>
                      <div
                        v-for="(error, index) of v$.selectedColor.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                      >
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="w-12 md:w-6 lg:w-6 p-1">  
                <div class="grid ml-0 mr-0">
                  <div class="col-4 pl-0 pr-1 pb-0">
                    <div class="field mb-1">
                      <label class="mb-1" for="multipack-numberOfPieces">Počet kusov</label>
                      <InputNumber inputClass="w-full"
                        inputId="multipack-numberOfPieces" :useGrouping="false"
                        disabled
                        v-model="this.multiPack.numberOfPieces"
                        name="multipack-numberOfPieces"
                        id="multipack-numberOfPieces"

                      >
                      </InputNumber>

                    </div>            
                  </div>
              
                  <div class="col-4 pl-1 pr-1 pb-0">
                    <div class="field mb-1">
                      <label class="mb-1" for="multipack-numberOfFreePieces">Voľné kusy</label>
                      <InputNumber inputId="multipack-numberOfFreePieces" :useGrouping="false"
                        disabled
                        v-model="this.numberOfFreePieces"
                        name="multipack-numberOfFreePieces"
                        id="multipack-numberOfFreePieces"
                        inputClass="w-full bg-green-200"
                        
                      >
                      </InputNumber>
                    </div>
                  </div> 
                  
                  <div class="col-4 pl-1 pr-0 pb-0">
                    <div class="field mb-1">
                      <label class="mb-1" for="multipack-numberOfReservedPieces">Rezerv. kusy</label>
                      <InputNumber inputClass="w-full" inputId="multipack-numberOfReservedPieces" :useGrouping="false"
                        disabled
                        v-model="this.multiPack.numberOfReservedPieces"
                        name="multipack-numberOfReservedPieces"
                        id="multipack-numberOfReservedPieces"
                      >
                      </InputNumber>
                    </div>
                  </div>  
                </div>
              </div>
              
              <div class="w-12 md:w-6 lg:w-6 p-1">  
                <Fieldset legend="Pridanie produktu do balíka" toggleable :collapsed="this.routeParams.packageId > 0" class="multipack">
                 
                    <div class="grid ml-0 mr-0">
                      <div class="col-10 pl-0 pr-1 pb-0">
                        <div class="field mb-2">
                          <label class="mb-1" for="package-category">Kategória</label>

                          <PrimevueSelect
                              id="package-category"
                              v-model="this.selectedCategory"
                              :options="this.categories"
                              optionLabel="name"
                              placeholder="Vyber kategóriu"
                              class="w-full"
                              :class="`${v$.selectedCategory.$error ? 'bg-red-200' : ''}`"
                              :invalid="v$.selectedCategory.$error"
                              @change="selectCategory(this.selectedCategory.id)"
                          >
                            <template #value="slotProps">
                              <div v-if="slotProps.value.id != 0" class="">
                                  <div class="text-sm">{{ slotProps.value.name }}</div>
                              </div>
                              <span v-else>
                                <div class="text-sm">{{ slotProps.placeholder }}</div>
                              </span>
                            </template>
                            <template #option="slotProps">
                                <div class="">
                                  <div>{{ slotProps.option.name }}</div>
                                </div>
                            </template>
                          </PrimevueSelect>  
                          <div
                              v-for="(error, index) of v$.selectedCategory.$errors"
                              :key="index"
                              class="text-sm font-italic text-red-400"
                          >
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                      <div class="col-2 pr-0 pl-0 pb-0">
                        <div class="field mb-1">
                          <label class="mb-1" for="product-number">Počet</label>
                          <InputNumber inputId="product-number" :useGrouping="false"
                            :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                            v-model="this.selectedProduct.numberOfProd"
                            name="product-number"
                            id="product-number"
                            :inputClass="`${v$.selectedProduct.numberOfProd.$error ? 'text-sm bg-red-200 w-full' : 'text-sm w-full'}`"
                            :invalid="v$.selectedProduct.numberOfProd.$error"
                          >
                          </InputNumber>
 
                        </div>            
                      </div>
                    </div>                              

                    <div class="grid ml-0 mr-0">
                      <div class="col-10 pl-0 pr-1 pb-0">
                        <div class="field mb-1">
                          <label class="mb-1" for="package-product">Produkt</label>
                          <div class="flex align-items-center justify-content-between " >
                            <PrimevueSelect
                                id="package-product"
                                :disabled="!this.selectedCategory.name"
                                v-model="this.selectedProduct"
                                filter
                                :options="this.products"
                                optionLabel="code"
                                placeholder="Vyber produkt"
                                class="w-full"
                                :class="`${v$.selectedProduct.code.$error ? 'bg-red-200' : ''}`"
                                :invalid="v$.selectedProduct.code.$error"
                               
                            >
                              <template #value="slotProps">
                                <div v-if="slotProps.value.id != 0" class="">
                                    <div class="text-sm">{{ slotProps.value.code }} - 
                                      {{ slotProps.value.name.length > 22 ? slotProps.value.name.slice(0, 22) + '...' : slotProps.value.name }} 
                                    </div>
                                </div>
                                <span v-else>
                                  <div class="text-sm">{{ slotProps.placeholder }}</div>
                                </span>
                              </template>
                              <template #option="slotProps">
                                  <div class="text-sm">
                                    <div>{{ slotProps.option.code }} - {{ slotProps.option.name }}</div>
                                  </div>
                              </template>
                            </PrimevueSelect>  
                            <PrimevueButton type="button" v-tooltip.top="{ value: 'Zobrazenie a výber produktov' }" class="products"
                                icon="pi pi-table" @click="this.visibleProducts = true" text severity="primary" size="large"
                            />
                          </div>
                          <div
                              v-for="(error, index) of v$.selectedProduct.$errors"
                              :key="index"
                              class="text-sm font-italic text-red-400"
                          >
                            {{ error.$message }}
                          </div>
                        </div>                            
                      </div>
                      <div class="col-2 pr-0 pl-0 pb-0">
                        <div class="field mb-1">
                          <label class="mb-1" for="package-length">Dĺžka</label>
                          <InputNumber inputId="package-length" :useGrouping="false"
                            :disabled="!(this.selectedCategory.name && this.selectedProduct.code)"
                            v-model="this.selectedProduct.length"
                            name="package-length"
                            id="package-length"
                            :inputClass="`${v$.selectedProduct.length.$error ? 'text-sm bg-red-200 w-full' : 'text-sm w-full'}`"
                            :invalid="v$.selectedProduct.length.$error"
                          >
                          </InputNumber>
 
                        </div>            
                      </div>
                    </div>

                    <div class="flex justify-content-center mb-1">
                      <!-- Náhľad obrázka -->
                      <div
                        class="image-container"
                        v-if="this.selectedProduct.image"
                      >
                        <!-- Obrázok -->
                        <img :src="this.selectedProduct.image" alt="Preview Image" class="preview-image"/>
                    
                      </div>
                      <div
                        class="image-container placeholder"
                        v-else
                      >
                      <i class="pi pi-image placeholder-icon"></i>
                      </div>
                    </div>

                    <div class="field flex justify-content-center">
                      <PrimevueButton @click="addProduct()" label="Pridať produkt do balíka" 
                        :disabled="!(this.selectedProduct.id != 0 && this.selectedProduct.length > 0)"
                        severity="success" text raised class="w-full uppercase"/>
                    </div>
                 
                </Fieldset>
              </div>
              
              <!--<div class="w-12 md:w-6 lg:w-6 p-1">
                
              -->

              <div v-for="(pack,index) in this.packages" v-bind:key="index"  class="w-12 md:w-6 lg:w-6 p-1">
                <Fieldset :legend="pack.product.code"
                          toggleable collapsed class="multipack">

                  <div class="grid ml-0 mr-0">
                    <div class="col-10 pl-0 pr-1 pb-0">
                      <div class="field mb-1">
                        <label class="mb-1" for="package-product">Názov</label>

                        <InputText
                            id="package-product"
                            disabled
                            
                            :placeholder="pack.product.code +' * '+pack.product.name"
                            class="text-sm w-full"
                        >
                        </InputText>  
  
                      </div>                            
                    </div>
                    <div class="col-2 pr-0 pl-0 pb-0">
                      <div class="field mb-1">
                        <label class="mb-1" for="package-length">Dĺžka</label>
                        <InputNumber 
                          inputClass="text-sm w-full"
                          inputId="package-length" :useGrouping="false"
                          disabled
                          v-model="pack.length"
                          name="package-length"
                          id="package-length"
                        >
                        </InputNumber>
  
                      </div>            
                    </div>
                  </div>

                  <div class="grid ml-0 mr-0">
                    <div class="col-8 pl-0 pr-1 pb-0">
                        <div class="mini-image-container mr-1">
                          <img :src="pack.product.image" 
                              :style="`${pack.imageHeight >= pack.imageWidth ? 'height:170px;' : 'width:190px;'}`"
                              @load="checkImageSize(index,$event)"
                              alt="Preview Image" class=""/>
                        </div>
                    </div>
                    <div class="col-4 pl-0 pr-0 pb-0">
                      <div class="field mb-1">
                        <label class="mb-1" for="package-numberOfPieces">Počet kusov</label>
                        <InputNumber 
                          inputId="package-numberOfPieces" :useGrouping="false"
                          
                          v-model="pack.numberOfPieces"
                          name="package-numberOfPieces"
                          id="package-numberOfPieces"
                          :inputClass="`${pack.numberOfPiecesIsWrong ? 'bg-red-200 w-full' : 'w-full'}`"
                          :invalid="pack.numberOfPiecesIsWrong"
                        >
                        </InputNumber>

                      </div>            

                      <div class="field mb-1">
                        <label class="mb-1" for="package-numberOfFreePieces">Voľné kusy</label>
                        <InputNumber inputId="package-numberOfFreePieces" :useGrouping="false"
                          disabled
                          v-model="pack.numberOfFreePieces"
                          name="package-numberOfFreePieces"
                          id="package-numberOfFreePieces"
                          inputClass="w-full bg-green-200"
                          
                        >
                        </InputNumber>
                      </div>

                      <div class="field mb-1">
                        <label class="mb-1" for="package-numberOfReservedPieces">Rezerv. kusy</label>
                        <InputNumber inputClass="w-full" inputId="package-numberOfReservedPieces" :useGrouping="false"
                          disabled
                          v-model="pack.numberOfReservedPieces"
                          name="package-numberOfReservedPieces"
                          id="package-numberOfReservedPieces"
                        >
                        </InputNumber>
                      </div>
                    </div>  
                  </div>
                    <div
                      v-if="pack.numberOfPiecesIsWrong"
                      class="text-sm font-italic text-red-400"
                    >
                      Počet kusov je nesprávny
                    </div>                     


                  <div class="field mt-1">
                    <div class="flex align-items-center justify-content-between" style="">
                      
                      <div class="w-8 pr-1" style="position: relative;">
                        <PrimevueButton @click="initOrders(index)" 
                            
                            label="test" 
                            style="height: 2rem;"
                            class="flex justify-content-between w-full " outlined
                            id="item-order">

                          <span v-if="pack.selectedOrder">{{pack.selectedOrder.orderCode}}</span>
                          <span v-if="!pack.selectedOrder">Vyber objednávku</span>

                          <span class="flex justify-content-center align-items-center" style="width: 1.8rem;">
                            <svg width="14" height="14" viewBox="0 0 14 14" 
                                  fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon p-button-icon">
                                  <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
                            </svg>
                          </span>
          
                        </PrimevueButton>

                        <div v-if="pack.visibleSelect" class="card" 
                            style="z-index: 10; position: absolute; top: 30px; left: 1px; min-width: 20rem; transform-origin: center top; margin-top: 2px;">
                  
                              <IconField iconPosition="left">
                              
                                <InputIcon>
                                  <i class="pi pi-search "/>
                                </InputIcon>
                                <InputText v-model="orderFilters['global'].value" placeholder="Vyhľadať" @input="onOrderFilter(index)" 
                              
                                />
                              </IconField>
                            <!-- </div> -->
                          <DataTable
                              
                              lazy paginator :rows="pack.selectParams.rows"
                              @page="onOrderPage(index,$event)"
                              :first="pack.selectParams.first"
                              :loading="selectLoading"
                              :totalRecords="pack.selectParams.totalRecords"
                              dataKey="id"
                              :value="pack.orderOptions"
                              :scrollHeight="`${200}px`"
                              :virtualScrollerOptions="{ itemSize: 40 }"
                              stripedRows
                              row-hover
                              scrollable
                              v-model:selection="pack.selectedOrder"
                              selectionMode="single"
                              :metaKeySelection="false"
                              @rowSelect="selectOrder(index)"
                              size="small"
                          >
                              <Column header="ID" field="orderCode" style="width: 5%">
                              </Column>
                              <Column header="Meno" field="customer.lastName" style="width: 50%">
                              </Column>    
                              <Column header="Obec" field="customer.city" style="width: 45%">
                              </Column>              
                          </DataTable>              
                        </div>
                      </div>  
                      
                      <div class="w-4 pl-1 pr-0">
                        <InputNumber inputId="numberOfReservedPieces" :useGrouping="false"
                          :disabled="!(pack.selectedOrder)"
                          v-model="pack.numberOfReservedItems"
                          name="numberOfReservedPieces"
                          id="numberOfReservedPieces"
                          :inputClass="`${pack.numberOfReservedItemIsWrong  ? 'bg-red-200 w-full' : 'w-full'}`"
                          :invalid="pack.numberOfReservedItemIsWrong"
                          placeholder="Rezer. kusy"
                        >
                        </InputNumber>
                      </div>

                    </div>  
                    <div
                      v-if="pack.numberOfReservedItemIsWrong"
                        class="text-sm font-italic text-red-400"
                      >
                        Chybný počet rezer. kusov
                    </div>
                    <div class="grid mt-1 ml-0 mr-0">
                      <div class="col-6 pt-1 pl-0 pr-1 pb-0 flex justify-content-center">
                          <PrimevueButton @click="saveOrReservePack(index)" label="Uložiť/Rezer." 
                          severity="success" text raised class="w-full uppercase"/>
                      </div>
                      <div class="col-6 pt-1 pl-0 pr-0 pb-0 flex justify-content-center">
                        <PrimevueButton @click="confirmDeletePack(pack.id)" label="Odstrániť" 
                        :disabled="pack.numberOfReservedPieces > 0"
                        severity="danger" text raised class="w-full uppercase"/>
                      </div>
                    </div>
                  </div>
                  
              
                      <ul class="list-none pl-2 shadow-1 surface-card border-round-md ">
                        <li v-for="r in pack.reservedItems" v-bind:key="r.id">
                          <div class="grid ml-0 mr-0">
                            <div class="col-10 flex pr-8 pb-0 pt-0 align-items-center">
                              <span class="w-8">{{r.order.orderCode}}</span>
                              <span class="w-1"> - </span>
                              <div class="w-3 flex justify-content-end">
                                <div class="text-right">{{r.numberOfItems}}</div>
                              </div>
                            </div>
                            <div class="col-2 pl-1 pb-0 pt-0 flex justify-content-end">
                              <PrimevueButton type="button" v-tooltip.top="{ value: 'Zrušenie rezervácie' }" icon="pi pi-times" 
                                  @click="confirmDelete(r.id)" text severity="danger" size="small"
                              />
                            </div>
                        </div>
                        </li>
                      </ul> 
                </Fieldset>
              </div>
 
            </div>           

            
            <div class="mt-2 mb-2 border-solid border-1 surface-border"></div>
            
            <div class="flex justify-content-center ">
              <div class="w-4 pt-0 pl-0 pr-1 pb-0 flex justify-content-center">
                <PrimevueButton type="submit" label="Uložiť balík" severity="success" text raised class="w-full uppercase"/>
              </div>
              <div class="w-4 pt-0 pl-0 pr-1 pb-0 flex justify-content-center">
                <PrimevueButton @click="confirmMultiPackDelete(this.multiPack.id)" label="Odstrániť balík" severity="danger"
                  v-tooltip.top="{ value: `${this.multiPack.numberOfPieces > 0 ? 'Odstrániť balík je možné až po odstránení všetkých produktov' : ''}` }"
                  :disabled="this.routeParams.packageId == 0" text raised class="w-full uppercase"/>
              </div>
              <div class="w-4 pt-0 pl-0 pr-0 pb-0 flex justify-content-center">
                <PrimevueButton @click="closeForm()" label="Zavrieť" 
                  text raised class="w-full uppercase"/>
              </div>    
                <!-- <router-link to="/mod-stock/packages" class="w-4 p-1">
                      <PrimevueButton label="Zavrieť" text raised class="uppercase"/>
                </router-link>
                -->
            </div>
          </form>
        </template>
    </PrimevueCard>

    <PrimevueCard  class="sm:w-12 md:w-10 lg:w-10 xl:w-6">
      <template #title>Pohyby s balíkom</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
        
            <ul class="pl-3">
              <li v-for="history in this.store.stockMovements" 
                  v-bind:key="history.id">
                <i class="pi pi-clock"></i>
                {{ Utils.formatToSlovak(history.createdAt) }}
                <PrimevueTag class="text-sm" :value="history.action" :style="{ backgroundColor: history.color }"/>
                - {{ history.user.firstName }} {{ history.user.lastName }}
              </li>
            </ul>
       
      </template>
    </PrimevueCard>

    <PrimevueDialog v-model:visible="this.visibleProducts" header="Produkty" :style="{ width: '60rem' }"> 
      <div class="grid">
        <div v-for="(prod,index) in this.products" v-bind:key="index" class="p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4">
            <PrimevueButton outlined  
               class="p-1  "  @click="setSelectProduct(prod) "
               @mouseover="this.hoverIndex = index"
               @mouseleave="this.hoverIndex = null"
               :style="buttonStyle(index)"   
            >
              <div class="grid w-full h-full">
                <div class="col-6 p-2">
                  <div class="text-left font-bold">{{ prod.code }}</div>
                  <div class="text-left mt-5">{{ prod.name }}</div>
                </div>
                <div class="col-6 p-1 flex justify-content-center">
                  <div class="w-full h-full flex justify-content-center align-items-center">
                    <img :src="prod.image" 
                        :style="`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`"
                        @load="checkImageSizeProd(index,$event)"
                        alt="Preview Image" class=""/>
                  </div>
                </div>
              </div> 
            </PrimevueButton>
        </div>
      </div>  
    </PrimevueDialog>

    <ConfirmDialog></ConfirmDialog>
  </div>
  
</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import PrimevueSelect from "primevue/dropdown";
import PrimevueCard from 'primevue/card';
import Utils from './utils';
import { required, helpers  } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import PrimevueTag from "primevue/tag";
import PrimevueCheckbox from 'primevue/checkbox';
import {FilterMatchMode} from "primevue/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import Fieldset from 'primevue/fieldset';
import PrimevueDialog from 'primevue/dialog';

const notBeZero = (value : number) => value > 0


export default {
  name: "PackageEdit",
  components: {

      PrimevueButton,
      PrimevueSelect,
      PrimevueCard,
      PrimevueTag,
      PrimevueCheckbox,
      DataTable,
      Column,
      IconField,
      InputIcon,
      Fieldset,
      PrimevueDialog,
  },
  data() {
    return {
      store,
      hoverIndex: null,
      reservations: [],
      numberOfFreePieces: 0,
      imitation: false,
      routeParams: null,
      oldLocation: "",
      typeOfAction: "",
      typeOfMultiPackAction: "",
      categories: [],
      selectedCategory: {id:0,name:""},
      colors: [],
      selectedColor: {id:0,code:""},
      products: [],
      selectedProduct: {id:0,code:"",name:"",image: "",length:0,numberOfProd: 0 },
      packages: [],
      multiPack: {
        id: 0,
        numberOfPieces: 0,
        numberOfReservedPieces: 0,
        location: "",
        color: {id:0,code:""},
        code: "",
      },
      orderOptions: [],
      visibleProducts: false,
      selectLoading: false,
      orderFilters : {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      selectParams: {
        first: 0,
        rows: 100,
        totalRecords: 0,
        filters:{global: "",
                 table:"order",
                 globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                },

      },
    }
  },

  computed: {
    Utils() {
      return Utils
    },

  },

  setup () {
    return {
      v$: useVuelidate()
    }
  },

  validations () {
    return {

      selectedCategory: {
           name: { required: helpers.withMessage('Kategória nesmie byť prázdna', required)},
                
            }, 
      selectedProduct: {
           code: { required: helpers.withMessage('Product nesmie byť prázdny', required)},
           length: { notBeZero: helpers.withMessage('Dĺžka nesmie byť nulová', notBeZero)},
           numberOfProd: { notBeZero: helpers.withMessage('Počet kusov nesmie byť nulový', notBeZero)},
            },   

      selectedColor: {
           code: { required: helpers.withMessage('Farba nesmie byť prázdna', required)},
                
              },      
      
    }
  },
  methods: {

    buttonStyle(index) {
      return {
        height: '172px',
        width: '295px',
        borderWidth: this.hoverIndex === index ? '2px' : '1px',
        borderColor: this.hoverIndex === index ? '#0000FF' : '#ccc', // Farba okraja
        transition: 'border-width 0.2s ease-in-out,border-color 0.2s ease-in-out'
      };
    },

    async submitHandler() {

      const packageId = parseInt(String(this.routeParams.packageId), 10)

      const formData = {
        id: this.multiPack.id,
        location: this.multiPack.location,
        color: this.selectedColor,

      }

      
      if (packageId > 0){
        const method = "PUT"
        const url = "/v1/multi-pack/" + packageId

        fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Balík bol uložený"
              })
              
              this.addStockMovement()
              this.oldLocation = this.multiPack.location
              this.typeOfAction = ""
              this.typeOfMultiPackAction = ""
              this.loadData()
              
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení balíka" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení balíka" + error
            })
        })
      }else{
        notie.alert({
                type: 'error',
                text: "Najprv je potrebné pridať do balíka produkty"
              })
      }

    },
    
    async addProduct(){
      
      const result = await this.v$.$validate()
      
      if (!result) {
        // notify user form is invalid
        return
      }
      const packageId = parseInt(String(this.routeParams.packageId), 10)
      
      this.multiPack.id = packageId

      let formData = {
        id: 0,
        location: this.multiPack.location,
        numberOfPieces: this.selectedProduct.numberOfProd,
        product: this.selectedProduct,
        color: this.selectedColor,
        length: this.selectedProduct.length,
        multiPack: this.multiPack,
      }

      let method = "POST"
      let url = "/v1/multi-pack"
      this.typeOfAction = "ADD"

      if (packageId > 0){
        
        url = "/v1/package"
        formData = {
          id: 0,
          location: this.oldLocation,
          numberOfPieces: this.selectedProduct.numberOfProd,
          product: this.selectedProduct,
          color: this.selectedColor,
          length: this.selectedProduct.length,
          multiPack: this.multiPack,
        }
      }else{
        this.typeOfMultiPackAction = "ADD"
      }

      fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Balík bol uložený"
              })
              if (packageId == 0){
                 this.multiPack = responseData.data
              }
              
              this.addStockMovement()

              this.v$.$reset()
              if (packageId > 0){
                
                this.loadData()
              }else{
                router.push("/mod-stock/packages/"+String(this.multiPack.id));
              }
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení balíka" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení balíka" + error
            })
          })

    },

    validateForm() {
      this.isSubmitted = true; 
  
    },

    setSelectProduct(product){
      this.selectedProduct = product
      this.visibleProducts = false
    },

    checkImageSizeProd(index,event) {
      this.products[index].imageWidth = event.target.naturalWidth;
      this.products[index].imageHeight = event.target.naturalHeight;
    },

    selectCategory(categoryId:number){
      fetch(this.store.Api_url + "/v1/product?query=deleted:0,category_id:"+categoryId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Zoznam produktov sa nepodarilo načítať"
              })
            } else {
              
              this.products = responseData.data
              this.products.forEach((prod) => {
                prod.hover = false
              })

            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní produktov" + error);
      })
    },

    checkImageSize(index,event) {
      this.packages[index].imageWidth = event.target.naturalWidth;
      this.packages[index].imageHeight = event.target.naturalHeight;
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    addStockMovement(){
      let dataMovement = {package:{id:this.multiPack.id},
                              action:"",
                              user:store.user,
                              color:"",
                         }
      if  (this.typeOfMultiPackAction == "ADD"){
        dataMovement.action = Utils.getAddTextAction("Balík")
        Utils.addStockMovement(dataMovement,"package_id","ADD",this.multiPack.id)
      }

      this.sleep(500);

      if  (this.typeOfAction == "ADD"){
        dataMovement.action = Utils.getAddPackTextAction(this.selectedProduct)
        Utils.addStockMovement(dataMovement,"package_id","ADD",this.multiPack.id)
      }

      if (this.oldLocation != this.multiPack.location && this.oldLocation != ""){
         dataMovement.action = Utils.getChangeLocationTextAction("Balík",this.multiPack.location)
         Utils.addStockMovement(dataMovement,"package_id","CHA",this.multiPack.id)

      }
      
      if (this.typeOfMultiPackAction == "DEL"){
         dataMovement.action = Utils.getDelTextAction("Balík")
         Utils.addStockMovement(dataMovement,"package_id","DEL",this.multiPack.id)

      }

    },

    printLabel(){
      Utils.printZplLabel(this.multiPack.id,"package")
    },

    setColors(){

      const imitat = this.imitation ? "1" : "0"

      fetch(this.store.Api_url + "/v1/color?query=deleted:0,imitation:"+imitat, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Zoznam farieb sa nepodarilo načítať"
              })
            } else {
              this.colors = responseData.data
            }
          })
          .catch((error) => {
            notie.alert({
                type: 'error',
                text: "Chyba pri načítaní farieb"
              })
            //this.$emit('error', "Chyba pri načítaní farieb" + error);
      })
    },

    saveOrReservePack(index:number){
      
      if (this.packages[index].selectedOrder){
        this.reserve(index)
      }
      if (this.packages[index].numberOfPieces != this.packages[index].oldNumberOfPieces){
        this.packages[index].numberOfPiecesIsWrong = !(this.packages[index].numberOfReservedPieces <= this.packages[index].numberOfPieces && this.packages[index].numberOfPieces > 0)
        if (this.packages[index].numberOfReservedPieces <= this.packages[index].numberOfPieces && this.packages[index].numberOfPieces > 0){
            this.savePack(index)
        }
      }
    },

    savePack(index:number){
      
      let method = "PUT"
      let url = "/v1/package/"+String(this.packages[index].id) 
      
      const formData = {numberOfPieces: this.packages[index].numberOfPieces}

      fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Balíček produktov bol uložený"
              })
              let dataMovement = {package:{id:this.multiPack.id},
                              action:"",
                              user:store.user,
                              color:"",
                         }
              dataMovement.action = Utils.getChangeNumberOfPiecesTextAction(this.packages[index].numberOfPieces - this.packages[index].oldNumberOfPieces,this.packages[index].product.code)
              Utils.addStockMovement(dataMovement,"package_id","CHA",this.multiPack.id)

              this.loadData()
              
            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri uložení balíka" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení balíčka produktov" + error
            })
          })

    },

    reserve(index:number){
      
      this.packages[index].numberOfReservedItemIsWrong = !(this.packages[index].numberOfReservedItems <= this.packages[index].numberOfFreePieces && this.packages[index].numberOfReservedItems > 0)

      if (this.packages[index].numberOfReservedItems <= this.packages[index].numberOfFreePieces && this.packages[index].numberOfReservedItems > 0)
      {
        const formData = {
          id: 0,
          numberOfItems: this.packages[index].numberOfReservedItems,
          package: this.packages[index],
          order: this.packages[index].selectedOrder,
          multiPack: this.packages[index].multiPack,
          color: this.packages[index].color,
          product: this.packages[index].product,
          deleted: false,
        }


        let method = "POST"
        let url = "/v1/reserved-item"
  
        this.typeOfAction = "CHA"
      

        fetch(store.Api_url + url, Security.requestOptions(method, formData))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
               
                notie.alert({
                  type: 'error',
                  text: responseData.data.message
                })
              } else {

                this.typeOfAction = ""
                //this.loadReservations()
                this.loadData()
              }
            })
            .catch((error) => {
              //this.$emit('error', "Chyba pri uložení balíka" + error);
              notie.alert({
                type: 'error',
                text: "Chyba pri rezervácii kusov" + error
            })
        })
      }
    },

    closeForm(){
      router.push("/mod-stock/packages")
    },

    confirmMultiPackDelete(mPackId:number) {
      if (this.multiPack.numberOfPieces == 0){
        this.$confirm.require({
            message: 'Naozaj chcete odstrániť balík?',
            header: 'Odstránenie balíka',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Áno",
            rejectLabel: "Nie",

            accept: () => {
              this.deleteMultiPack(mPackId)
              
            },

        });
      }
    },
    deleteMultiPack(mPackId:number){
     
        Security.requireToken();
        fetch(store.Api_url + "/v1/multi-pack/" + String(mPackId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
               
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Balík sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                //this.packages = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Balík bol odstránený",
                  position: "bottom"
                })
                this.typeOfMultiPackAction = "DEL"
                this.addStockMovement()
                //this.loadData()
                router.push("/mod-stock/packages")
              }
            })
            .catch((error) => {
              alert('Chyba pri odstránení balíka: ' + error)
            })
      //}
    },

    confirmDelete(id:number){
      this.$confirm.require({
          message: 'Naozaj chcete zrušiť túto rezerváciu?',
          header: 'Zrušenie rezervácie',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            //this.action = Utils.getDelTextAction("Kus")
            this.typeOfAction = "DEL"
            
            this.deleteReservation(id)

          },

      });
    },

    confirmDeletePack(id:number){
      this.$confirm.require({
          message: 'Naozaj chcete odstrániť tieto kusy?',
          header: 'Odstránenie kusov',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            //this.action = Utils.getDelTextAction("Kus")
            this.typeOfAction = "DEL"
            
            this.deletePack(id)

          },

      });
    },

    deleteReservation(id:number){
      
        Security.requireToken();
       
        fetch(store.Api_url + "/v1/reserved-item/" + String(id), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                
                //this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Rezerváciu kusov sa nepodarilo zrušiť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                notie.alert({
                  type: 'success',
                  text: "Rezervácia kusov bola zrušená",
                  position: "bottom"
                })
                //this.package = responseData.data 
                //this.loadReservations()
                this.loadData()
              }
            })
            .catch((error) => {
              alert('Chyba pri zrušení rezervácie kusov: ' + error)
            })
      //}
    },
    
    deletePack(id:number){
      
      Security.requireToken();
     
      fetch(store.Api_url + "/v1/package/" + String(id), Security.requestOptions("DELETE"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {

              notie.alert({
                  type: 'error',
                  text: "Kusy sa nepodarilo odstrániť: " + responseData.message,
                  position: "top"
                })           
            } else {

              notie.alert({
                type: 'success',
                text: "Kusy boli úspešne odstránené",
                position: "bottom"
              })

              this.loadData()
            }
          })
          .catch((error) => {
            alert('Chyba pri odstránení kusov: ' + error)
          })
      
    },

    selectOrder(index:number){

      this.packages[index].visibleSelect = false

    },
    onOrderPage(index,event) {
        this.packages[index].selectParams.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyDataOrders(index,this.packages[index].selectParams)
    },
      
    onOrderFilter(index:number) {
        this.packages[index].selectParams.filters.global = this.orderFilters.global.value
        this.packages[index].selectParams.first = 0
        
        if(this.packages[index].selectParams.filters.global.length > 2){
           this.loadLazyDataOrders(index,this.packages[index].selectParams)
          }
    },

    initOrders(index:number){

        this.packages[index].visibleSelect = !this.packages[index].visibleSelect
        this.packages[index].selectParams.first = 0
        this.packages[index].selectParams.rows = 100
        this.packages[index].selectParams.filters.global = ""
        this.packages[index].orderfilters = {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS},

        }
        this.loadLazyDataOrders(index,this.packages[index].selectParams)
        this.isMovement = false
        
        this.typeOfAction = ""
        this.typeOfMultiPackAction = ""
    },

    loadReservations(){
      fetch(store.Api_url + "/v1/reserved-item?query=deleted:0,package_id:"+String(this.package.id), Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam rezervovaných kusov sa nepodarilo načítať: " + responseData.message,
                      position: "top"
                    })           
            } else {
              
              this.reservations = responseData.data

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam rezervovaných kusov sa nepodarilo načítať: " + error,
                      position: "top"
            }) 
            this.reservations = []          
      });

    },

    loadData(){

      this.setColors()

      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.message,
                      position: "top"
                    })           
            } else {
              
              this.categories = responseData.data

            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
            })    
            this.categories = []       
      });



      if (parseInt(String(this.routeParams.packageId), 10) > 0) {
        
        const packageId = String(this.routeParams.packageId)

        Utils.updateStockMovement("package_id",packageId)

        fetch(store.Api_url + "/v1/multi-pack/" + packageId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Balík sa nepodarilo načítať: " + responseData.error,
                      position: "top"
                })         
              } else {
                
                this.multiPack = responseData.data
                this.selectedCategory =  {id:0,name:""}
                this.selectedColor =  this.multiPack.color
                this.selectedProduct = {id:0,code:"",name:"",image: "",length:0, numberOfProd:0}
                this.oldLocation = this.multiPack.location
                this.packages = this.multiPack.packages
                this.numberOfFreePieces = this.multiPack.numberOfPieces - this.multiPack.numberOfReservedPieces
                this.packages.forEach((pack) => {
                  pack.numberOfPiecesIsWrong = false;
                  pack.numberOfReservedItems = 0;
                  pack.numberOfReservedItemIsWrong = false;
                  pack.selectedOrder = null;
                  pack.visibleSelect = false;
                  pack.selectParams = {...this.selectParams};
                  pack.orderFilters = {...this.orderFilters};
                  pack.orderOptions = [];
                  pack.oldNumberOfPieces = pack.numberOfPieces
                })
                this.typeOfAction = ""
                this.typeOfMultiPackAction = ""
                //this.selectCategory(this.selectedCategory.id)
                //this.loadReservations()
              }
            })
            .catch((error) => {
              //this.$emit('error', "Chyba pri načítaní balíka" + error);
              notie.alert({
                      type: 'error',
                      text: "Chyba pri načítaní balíka: " + error,
                      position: "top"
              })           
        })
      }else{
        store.stockMovements = []
        //this.numberOfFreePieces = this.package.numberOfPieces
      }

    },

    loadLazyDataOrders(index:number,params) {
        this.selectLoading = true;

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
        .then((response) => response.json())
        .then((responseData) => {
          if (!responseData.error) {
            if (responseData.data){
              this.packages[index].orderOptions = responseData.data
            }else{this.packages[index].orderOptions = []}
            this.packages[index].selectParams.totalRecords = responseData.totalRecords
            this.selectLoading = false;
          }
        })
        .catch((error) => {
          this.packages[index].orderOptions = []
          this.selectLoading = false;
        })
    },

  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]
 
        //this.initSelectFilters()
        //this.loadLazyDataOrders(this.selectParams)

        this.loadData()  

        next()
      }
  },

  beforeMount() {
    
    if (Security.requireToken()){
      
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]
      
      //this.initSelectFilters()
      //this.loadLazyDataOrders(this.selectParams)

      this.loadData()

    }

  }
}
</script>



<style scoped>

</style>